import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
var UserAvatar = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, _b = _a.tooltipPlacement, tooltipPlacement = _b === void 0 ? 'left-end' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c;
    var sizePx = size === 'medium' ? '32px' : '26px';
    var fontPx = size === 'medium' ? '16px' : '12px';
    return (React.createElement(Tooltip, { title: firstName + " " + lastName, placement: tooltipPlacement },
        React.createElement(Avatar, { sx: { bgcolor: 'primary.main', width: sizePx, height: sizePx, fontSize: fontPx } }, "" + firstName.slice(0, 1) + lastName.slice(0, 1))));
};
export default UserAvatar;
//# sourceMappingURL=UserAvatar.js.map